import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiAgentUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/agents",
  "/:app_group_id/generative_ai/agents/campaign_qa",
  // Archiving/unarchiving changes the non-archived agent count that the
  // agent-definition object-creation limit is resolved against, and the agents
  // list gates its Create button on that limit (useAgentDefinitionLimit) while
  // this mutation runs on the same page; without this the button stays disabled
  // after the user archives their way back under the limit.
  "/engagement/:app_group_id/feature_limitations",
];
